export enum ERROR_CODE {
  UNAUTHORIZED = 401,
  BAD_REQUEST = 400,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500,
  NOT_FOUND = 404,
}

export enum STRING_ERROR_CODE {
  SENSITIVE_CONTENT = 'CONTENT_SAFETY',
  INVALID_REQUEST = 'INVALID_REQUEST',
  SERVER_ERROR = 'SERVER_ERROR',
}

export const ERROR_MESSAGES = {
  [ERROR_CODE.UNAUTHORIZED]: 'Your session has expired. Please log in again.',
  [ERROR_CODE.BAD_REQUEST]: 'Invalid request. Please try again with a different message.',
  [ERROR_CODE.UNPROCESSABLE_ENTITY]: 'This message contains sensitive content that cannot be processed.',
  [ERROR_CODE.INTERNAL_SERVER_ERROR]: 'An error occurred. Please try again.',
  [STRING_ERROR_CODE.SENSITIVE_CONTENT]: 'This message contains sensitive content that cannot be processed.',
  [STRING_ERROR_CODE.INVALID_REQUEST]: 'Invalid request. Please try again with a different message.',
  [STRING_ERROR_CODE.SERVER_ERROR]: 'An error occurred. Please try again.',
}

export const API_RETRY_MAX_LIMIT_REACHED = 'Max token refresh attempts reached, logging out'
